import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/index.vue";

import Home from "../views/Home.vue";
import NotEngineer from "../views/notEngineer.vue";

import SubmitSuccess from "../views/submitSuccess.vue";
import PhoneList from "../views/phonelist.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index
  },
  {
    path: "/home",
    name: "Home",
    component: Index
  },
  {
    path: "/engineer/:sourceType?",
    name: "Home",
    component: Home
  },
  {
    path: "/notEngineer/:sourceType?",
    name: "NotEngineer",
    component: NotEngineer
  },
  {
    path: "/submitSuccess",
    name: "SubmitSuccess",
    component: SubmitSuccess
  },
  {
    path: "/phonelist",
    name: "PhoneList",
    component: PhoneList
  }
];

const router = new VueRouter({
  routes
});

export default router;
